;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import Link from 'next/link';

import { Button, ModalBody, ModalFooter } from 'reactstrap';
import { useUser } from '../../../contexts/UserContext';
import ProfileModalListItem from './ProfileModalListItem';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

type Props = {
  toggle: () => void;
  dictionary: Partial<Dictionaries>;
};
function ProfileModalOutro({ toggle, dictionary }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const { candidate } = useUser();

  return (
    <>
      <ModalBody>
        <div className="py-4">
          <h2>{formatMessage({ id: 'well-done' })}</h2>
          <span className="d-block mb-3">{formatMessage({ id: 'profile_form_outro_intro' })}</span>
          <div className="bg-light p-3 my-5">
            <ul className="unstyled ms-3">
              <ProfileModalListItem text={formatMessage({ id: 'profile_form_outro_agency_followup' })} />
              <ProfileModalListItem text={formatMessage({ id: 'profile_form_outro_completed_profile' })} />
              {candidate?.cv && <ProfileModalListItem text={formatMessage({ id: 'attachment-added' })} />}
              {candidate?.receiveMatchmail && (
                <ProfileModalListItem text={formatMessage({ id: 'profile_form_outro_receive_matchmail' })} />
              )}
            </ul>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" className="w-100" onClick={() => toggle()}>
          {formatMessage({ id: 'mysynergie_goto_profile' })}
        </Button>

        <Link href="/jobs" className="btn btn-white mt-3 w-100 mx-auto d-block">
          {formatMessage({ id: 'to-all-vacancies' })}
        </Link>
      </ModalFooter>
    </>
  );
}

export default ProfileModalOutro;
